import { useStore } from '@tanstack/react-store'

import { builderStore, builderStoreActions } from '@/lib/store/builder.store'

// useBuilderStore(state => state.isEditable)
export const useBuilderStore = <T>(selector: (state: typeof builderStore.state) => T) => {
  return useStore(builderStore, selector)
}

export function useBuilderStoreActions() {
  return builderStoreActions
}
